export const MUTATIONS_CLARA = {
  SET_OPEN: 'setOpen',
  TOGGLE: 'toggle',
  SET_WIDTH: 'setWidth',
  REQUEST_CONVERSATION: 'requestConversation',
  CLEAR_REQUEST: 'clearRequest'
};

/** Limites do painel: abaixo de 360 a conversa fica ilegível; acima de 720 sobra pouco app. */
const MIN_WIDTH = 360;
const MAX_WIDTH = 720;
const WIDTH_KEY = 'clara-panel-width';

export const clampWidth = (value) => Math.min(MAX_WIDTH, Math.max(MIN_WIDTH, Math.round(value)));

export default {
  setOpen(state, value) {
    state.open = Boolean(value);
  },

  toggle(state) {
    state.open = !state.open;
  },

  /* Pedido vindo de FORA do painel ("conversar sobre este cliente"). Guardamos
     o pedido em vez de mexer na conversa daqui: quem sabe encerrar a conversa
     atual e montar a nova e o painel, e ele pode nem estar montado ainda. O
     contador existe porque dois pedidos iguais seguidos (mesmo cliente, dois
     cliques) precisam disparar o watch duas vezes. */
  requestConversation(state, context) {
    state.request = { ...context, seq: state.request.seq + 1 };
    state.open = true;
  },

  clearRequest(state) {
    state.request = { customer: null, operation: null, seq: state.request.seq };
  },

  setWidth(state, width) {
    state.width = clampWidth(width);

    try {
      localStorage.setItem(WIDTH_KEY, String(state.width));
    } catch (e) {
      // Sem localStorage a largura só não persiste entre sessões; não é erro de uso.
    }
  }
};

export { MIN_WIDTH, MAX_WIDTH, WIDTH_KEY };
